<template>
  <div class="summary-banner-content">
    <div
      class="summary-banner-image"
      :style="{ backgroundImage: `url(${summaryPageStoreBannerImageSrc})` }"
    ></div>
    <div class="summary-overlay-image">
      <h1 class="summary-banner-title">
        {{ summaryPageStoreBannerImageTitle }}
      </h1>
    </div>
  </div>
</template>

<script lang="ts">
import { PageStoreContract } from '@/data/store/page.store.contract'
import SummaryPageMixin from "@/mixins/summary-page-mixin"
import { SummaryPageStore } from '@/store/verbal-identity-page/summary-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({})
export default class SummaryBannerSection extends Mixins(SummaryPageMixin) {
  summaryPageStore: PageStoreContract = getModule(SummaryPageStore, this.$store)

  get summaryPageStoreBannerImageTitle(): string {
    return this.getElementTitle(0, 0)
  }

  get summaryPageStoreBannerImageSrc(): string {
    return this.getElementMedia(0, 0)
  }

  async getSummaryPageStore(): Promise<void> {
    await this.summaryPageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.summaryPageStore.isLoading) {
      await this.getSummaryPageStore()
    }
  }
}
</script>

<style lang="scss">
.summary-banner-content {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: gray;
  max-height: 28rem;
  width: 100%;
  justify-items: center;
  justify-content: center;
}

.summary-banner-image {
  position: relative;
  width: 100%;
  height: 451px;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
}

.summary-overlay-image {
  position: absolute;
  bottom: 9rem;
  left: 1rem;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: white;
  z-index: 1;
  pointer-events: none;
  text-align: left;
}

.summary-banner-title {
  font-size: 8rem;
  width: 1rem;
  margin: 0;
  font-weight: 400;
  letter-spacing: -0.01em;
  text-align: left;
}
</style>
